export default __webpack_public_path__ + "static/media/step-4@3x.d43ccc1d.png";